<template>
    <div class="request-sign">
        <el-tabs class="soft-update-tab" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="tab in tabList" :key="tab.name" :label="tab.label" :name="tab.name">
            </el-tab-pane>
        </el-tabs>
        <div class="topBar">
            <div class="opeItem">
                <div class="itemTitle">产品类型</div>
                <el-select v-model="record.productType" placeholder="请选择" clearable @change="changeProductType">
                    <el-option v-for="(item, index) in productList" :key="'productType' + index"
                        :value="item.productTypeId" :label="item.productTypeName">
                    </el-option>
                </el-select>
            </div>
            <div class="opeItem">
                <div class="itemTitle">产品套餐/型号</div>
                <el-select style="width: 300px" v-model="record.productModel" placeholder="请选择" clearable
                    @change="searchData">
                    <el-option v-for="item in productModelList" :key="item.id" :value="item.id" :label="item.name">
                    </el-option>
                </el-select>
            </div>
            <div class="opeItem">
                <el-date-picker class="ml10" v-model="record.dateTime" type="daterange" range-separator="~"
                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                    @change="searchData" @clear="searchData">
                </el-date-picker>
            </div>
            <div class="opeItem">
                <el-input v-model="record.keywords" placeholder="请输入" clearable @clear="searchData"
                    @keyup.enter.native="searchData">
                    <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;"
                        @click="searchData"></i>
                </el-input>
            </div>
        </div>
        <!--表格-->
        <div class="tableContainer">
            <el-table :data="tableData" style="width: 100%; margin: auto;"
                :header-cell-style="{ background: '#d3d9e1', color: '#4C545D', fontSize: '16px' }"
                :cell-style="{ fontSize: '14px', color: '#333333' }" stripe border>
                <div slot="empty" style="font-size: 16px;text-align: center;color: #333333">
                    暂无数据
                </div>
                <!-- <el-table-column align="center" type="selection"></el-table-column> -->
                <el-table-column align="center" label="序号" width="70">
                    <template slot-scope="scope">
                        <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="产品类型" prop="productType" width="140"></el-table-column>
                <el-table-column align="center" label="产品套餐/型号" prop="productModel" width="350"></el-table-column>
                <el-table-column align="center" label="销售类型" prop="saleType" width="120"></el-table-column>
                <el-table-column align="center" label="工程名称" prop="projectName"></el-table-column>
                <el-table-column align="center" label="申请人" prop="applicant" width="100"></el-table-column>
                <el-table-column align="center" label="所属公司" prop="company"></el-table-column>
                <el-table-column align="center" label="申请时间" prop="applyTime" width="160"></el-table-column>
                <el-table-column align="center" prop="approvedStatusName" label="签审结果" v-if="activeName === 'signed'"
                    width="120">
                </el-table-column>
                <el-table-column align="center" label="操作" width="100">
                    <template slot-scope="scope">
                        <div class="opeBtn canUse" @click="openSignOrDetailDialog(scope.row)">{{ activeName === 'unSign'
                            ? '审核' : '详情' }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="paginationContainer">
            <el-pagination style="text-align: center; margin-top: 20px; margin-bottom: 10px;"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="[10, 25, 50, 100, 150]" :page-size="pageSize"
                layout="total,sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <SignOrDetailDialog :dialogVisible="dialogVisible" :dialogTitle="'申请详情'" @closeDialog="closeDialog"
            :rowItem="rowItem" :isForm="isForm" @getData="getData" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SignOrDetailDialog from './SignOrDetailDialog.vue';
import { getPendingApprovalList, getApprovedList, getApprovalInfoById, getPendingApprovalInfoById } from "@/api/softUpdate";
import {
    getProductPackageList,
} from "@/api/productActivate";
export default {
    components: {
        SignOrDetailDialog,
    },
    computed: {
        ...mapGetters(['getUserName']),
    },
    data() {
        return {
            rowItem: {},
            dialogVisible: false,
            isForm: false,
            tabList: [
                { name: 'unSign', label: '待审批' },
                { name: 'signed', label: '已审批' },
            ],
            activeName: "unSign",
            record: {
                productType: "",
                productModel: "",
                dateTime: "",
                keywords: "",
            },
            productList: [],
            productModelList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            tableData: [
                // { saleType: "内销", productType: "GMVisual 工作站", productModel: "GMVisual Master(GBMS-MPC005U100)", projectName: "珠海研发大楼", applicant: "李莉莉", company: "珠海格力电器股份有限公司", applyTime: "2022-03-06 10:00:00", applyStatus: 3 },
            ],
        }
    },
    methods: {
        convertData(list) {
            this.tableData = [];
            list.map((item) => {
                this.tableData.push({
                    ...item,
                    productType: item.productTypeName,
                    productModel: item.productPackageName,
                    saleType: item.marketName,
                    projectName: item.engineeringName,
                    applicant: item.applicationName,
                    company: item.applicationCompany,
                    applyTime: item.applicationTime,
                });
            })
        },
        initParams() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.record = {
                productType: "",
                productModel: "",
                dateTime: "",
                keywords: "",
            };
        },
        async handleClick() {
            this.initParams();
            this.getData();
        },
        async openSignOrDetailDialog(row) {
            this.isForm = this.activeName === 'unSign' ? true : false;
            let data = {
                upgradeId: row.productUpgradeId,
                productId: row.productId,
            };
            getApprovalInfoById(data).then(async (res) => {
                this.rowItem = {
                    ...row,
                    ...res.returnData,
                    applyStatus: res.returnData.approvedStatus + 2,
                    flowRemark: res.returnData.approvedComment,
                    approver: res.returnData.approvedName,
                    applicationName: res.returnData.applicationName,
                    productSerialNumber: res.returnData.productSerialNumber,
                    engineeringAddress: res.returnData.engineeringAddress,
                };
                await this.$nextTick();
                this.dialogVisible = true;
            })

        },
        closeDialog() {
            this.dialogVisible = false;
        },
        searchData() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.getData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getData();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData();
        },
        getData() {
            let data = {
                username: this.getUserName,
                pageNo: this.currentPage,
                pageSize: this.pageSize,
                productType: this.record.productType,
                productPackage: this.record.productModel,
                keywords: this.record.keywords,
                startTime: '',
                endTime: '',
            };
            if (this.record.dateTime) {
                data.startTime = this.record.dateTime[0];
                data.endTime = this.record.dateTime[1];
            }
            if (this.activeName === "unSign") {
                getPendingApprovalList(data).then((res) => {
                    this.convertData(res.returnData?.productUpgradeDTOList);
                    this.total = res.returnData?.count;
                })
            } else {
                getApprovedList(data).then((res) => {
                    this.convertData(res.returnData?.productUpgradeDTOList);
                    this.total = res.returnData?.count;
                })
            }
        },
        changeProductType() {
            this.record.productModel = '';
            let aimDataSource = this.productList.filter(item => item.productTypeId == this.record.productType);
            this.productModelList = aimDataSource[0] ? aimDataSource[0].productPackageList : [];
            this.searchData();
        },
        // 初始化产品类型选项
        initProductOption() {
            getProductPackageList().then(res => {
                if (res.returnCode == '100') {
                    this.productList = res.returnData;
                }
            }).catch(e => e);
        },
    },
    mounted() {
        this.getData();
        this.initProductOption();
    },
}
</script>

<style scoped lang="less">
.soft-update-tab {
    /deep/ .el-tabs__item {
        font-size: 16px;
    }

    /deep/ .el-tabs__item:hover {
        color: #1f65ff;
    }

    /deep/ .el-tabs__item.is-active {
        color: #1f65ff;
    }

    /deep/.el-tabs__active-bar {
        background-color: #1f65ff;
    }

    /deep/ .el-tabs__nav-wrap::after {
        color: #d3d9e1;
    }
}

.ml10 {
    margin-left: 10px;
}

/*表格按钮样式*/
.opeBtn {
    display: inline-block;
}

.banUse {
    color: #bbb9b9 !important;
    cursor: not-allowed !important;
}

.canUse {
    cursor: pointer;
    color: #31A4FF;
}

/*顶部操作栏样式*/
.topBar {
    margin: 10px 14px 10px 0;
    text-align: left;

    .opeItem {
        display: inline-block;
        margin-right: 20px;

        .itemTitle {
            display: inline-block;
            font-size: 16px;
            padding: 0 10px;
        }
    }

    .opeItem:last-child {
        margin-right: 0px;
    }
}

.tableContainer {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

@media (max-width: 767px) {
    .topBar {
        margin: 10px 0;
    }

    .topBar .opeItem {
        display: block;
        margin-right: 0;
        margin-bottom: 12px;
    }

    .topBar .opeItem .itemTitle {
        display: block;
        padding: 0 0 4px 0;
    }

    /deep/ .topBar .el-select,
    /deep/ .topBar .el-input,
    /deep/ .topBar .el-date-editor {
        width: 100% !important;
    }

    /deep/ .el-pagination__sizes,
    /deep/ .el-pagination__jump,
    /deep/ .el-pagination__total {
        display: none !important;
    }
}
</style>